import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Field } from "@/components/common";
import { api, errorMessage } from "@/lib/api";
import { fmtMinutes } from "@/lib/format";

export function TimeAdjustDialog({ open, onOpenChange, roId, task, onDone }) {
  const [minutes, setMinutes] = useState("");
  const [billable, setBillable] = useState("");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  if (!task) return null;
  const submit = async () => {
    setBusy(true);
    try {
      await api.post(`/repair-orders/${roId}/tasks/${task.id}/time-adjust`, { minutes: Number(minutes), reason, billable_minutes: billable === "" ? null : Number(billable) });
      toast.success("Temps corrigé et journalisé");
      onOpenChange(false);
      setMinutes(""); setBillable(""); setReason("");
      onDone?.();
    } catch (e) {
      toast.error(errorMessage(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined} data-testid="time-adjust-dialog">
        <DialogHeader><DialogTitle>Corriger le temps — {task.description}</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">Temps travaillé actuel : <strong>{fmtMinutes(task.work_minutes)}</strong> · attente {fmtMinutes(task.waiting_minutes)}. La correction est ajoutée au journal avec votre nom et le motif.</p>
        <div className="grid gap-3 sm:grid-cols-2">
          <Field label="Correction (minutes, ± )"><Input type="number" value={minutes} onChange={(e) => setMinutes(e.target.value)} placeholder="-15 ou 20" data-testid="time-adjust-minutes" /></Field>
          <Field label="Temps facturable (min, facultatif)"><Input type="number" min={0} value={billable} onChange={(e) => setBillable(e.target.value)} placeholder={String(task.work_minutes || 0)} data-testid="time-adjust-billable" /></Field>
        </div>
        <Field label="Motif (obligatoire)"><Textarea value={reason} onChange={(e) => setReason(e.target.value)} rows={2} placeholder="Ex : chrono oublié en pause déjeuner" data-testid="time-adjust-reason" /></Field>
        <DialogFooter><Button onClick={submit} disabled={busy || minutes === "" || !reason.trim()} data-testid="time-adjust-submit">Enregistrer la correction</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
